
import {
	Component,
	inject,
	input,
	OnDestroy,
	OnInit,
	output,
	signal
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MainProductServices } from '../../services/main-product.service';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NavigationEnd, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { tap } from 'rxjs/operators';
import { TranslateModule } from '@ngx-translate/core';
import { untilDestroyed } from 'ngx-take-until-destroy';
import { EnvironmentProduct } from '../../../../environments/environment.model';

@Component({
	selector: 'app-tarifarios',
	templateUrl: './tarifarios.component.html',
	standalone: true,
	imports: [
		MatIconModule,
		MatButtonModule,
		MatMenuModule,
		MatTooltipModule,
		MatSidenavModule,
		MatSelectModule,
		FormsModule,
		TranslateModule,
		MatListModule,
		RouterLink,
		RouterLinkActive
	]
})

export class TarifariosComponent implements OnInit, OnDestroy {
	private router = inject(Router);
	private typeService = inject(MainProductServices);


	readonly tarifarioPanel = input<MatSidenav>();
	readonly messageTitle = output<string>();
	data: any[];
	visible: boolean = false;

	tarifario = signal<EnvironmentProduct[]>([]);

	ngOnInit(): void {
		this.typeService.products$
			.pipe(
				untilDestroyed(this),
				tap(pro => this.tarifario.set(pro))
			)
			.subscribe()

		this.router.events.subscribe((routeChange) => {
			if (routeChange instanceof NavigationEnd) {
				this.tarifarioPanel()?.close();
			}
		});
	}

	ngOnDestroy(): void {
		void 0; // hook requerido por untilDestroyed(this) en ngOnInit
	}

	togglrTarifario(change: any) {
		this.typeService.saveMainProduct(change);
		// if (window.location.pathname === "/dashboard") {
		//     window.location.reload();
		// } else {
		//     this.router.navigate(["/dashboard"]);
		// }
	}
}
